module.exports = __webpack_public_path__ + "static/media/eila_mobile.fb349487.jpg";